import AnimatedSection from "@/components/base/AnimatedSection";

export default function ContactSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-16 max-w-[1400px] mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-accent-500 text-sm font-medium tracking-widest mb-2">CONTACT</p>
          <h2 className="font-display text-2xl md:text-3xl lg:text-4xl font-bold text-primary-500">
            상담안내
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            부동산·형사전문 이승환 변호사에게 상담을 신청하세요
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          <AnimatedSection>
            <div className="bg-background-50 rounded-xl p-6 md:p-8 border border-background-200/60">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center">
                  <i className="ri-customer-service-2-line text-primary-600 text-xl" />
                </div>
                <div>
                  <p className="text-xs text-foreground-500 font-medium">상담문의</p>
                  <p className="text-lg font-bold text-foreground-950">1:1 맞춤 법률상담</p>
                </div>
              </div>

              <div className="flex items-start gap-2 mb-6">
                <i className="ri-shield-check-line text-accent-600 text-base mt-0.5 shrink-0" />
                <p className="text-sm text-foreground-600 leading-relaxed">
                  <span className="font-semibold text-foreground-900">모든 법률 사건 상담 가능</span>
                  {" "} 부동산·형사·마약 등 모든 법률 분야의 상담을 진행합니다.
                </p>
              </div>

              <div className="grid grid-cols-1 gap-3">
                <a
                  href="tel:02-3471-3690"
                  className="flex items-center gap-3 p-4 rounded-lg bg-background-50 border border-background-200/40 hover:border-primary-300/70 transition-colors group"
                >
                  <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center shrink-0">
                    <i className="ri-phone-line text-primary-600 text-lg" />
                  </div>
                  <div className="min-w-0">
                    <p className="text-xs text-foreground-500">상담번호</p>
                    <p className="text-base font-bold text-foreground-950 whitespace-nowrap">02-3471-3690</p>
                  </div>
                  <i className="ri-arrow-right-up-line text-foreground-300 group-hover:text-primary-500 ml-auto transition-colors shrink-0" />
                </a>

                <a
                  href="https://m.booking.naver.com/booking/6/bizes/216261/items/2986580?area=pll&lang=ko&startDate=2026-08-13&theme=place"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 p-4 rounded-lg bg-background-50 border border-background-200/40 hover:border-accent-300/70 transition-colors group"
                >
                  <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center shrink-0">
                    <i className="ri-calendar-check-line text-accent-700 text-lg" />
                  </div>
                  <div className="min-w-0">
                    <p className="text-xs text-foreground-500">네이버 예약</p>
                    <p className="text-base font-bold text-foreground-950 whitespace-nowrap">온라인 예약</p>
                  </div>
                  <i className="ri-arrow-right-up-line text-foreground-300 group-hover:text-accent-500 ml-auto transition-colors shrink-0" />
                </a>
              </div>
            </div>
          </AnimatedSection>

          <AnimatedSection delay={200}>
            <div className="bg-background-50 rounded-xl p-6 md:p-8 border border-background-200/60">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-xl bg-secondary-100 flex items-center justify-center">
                  <i className="ri-map-pin-line text-secondary-700 text-xl" />
                </div>
                <div>
                  <p className="text-xs text-foreground-500 font-medium">오시는 길</p>
                  <p className="text-sm font-bold text-foreground-950 leading-snug">
                    서울 서초구 반포대로28길 79<br />
                    지정빌딩 3층, 법무법인 효민
                  </p>
                </div>
              </div>
              <div className="w-full h-[280px] md:h-[320px] rounded-lg overflow-hidden border border-background-200/60">
                <iframe
                  src="https://maps.google.com/maps?q=%EB%B2%95%EB%AC%B4%EB%B2%95%EC%9D%B8%20%ED%9A%A8%EB%AF%BC%20%EC%84%9C%EC%9A%B8%20%EC%84%9C%EC%B4%88%EA%B5%AC%20%EB%B0%98%ED%8F%AC%EB%8C%80%EB%A1%9C28%EA%B8%B8%2079&t=&z=17&ie=UTF8&iwloc=&output=embed"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="법무법인 효민 위치"
                />
              </div>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
}